import { useContext } from "react";
import { ThemeContext } from "../Contexts/ThemeContext";

/**
 * Returns current theme mode and setter.
 * themeMode: "default" | "dark" | "light"
 * setThemeMode(mode): function to change theme
 */
export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
}
